import * as React from 'react';
import { determineValidations } from './validations.js';
import InputButtonGroup from './formElements/InputButtonGroup.js';
import Input from './formElements/Input.js';
import Hidden from './formElements/Hidden.js';
import Checkbox from './formElements/Checkbox.js';
import Radio from './formElements/Radio.js';
import StepButtons from './formElements/StepButtons.js';
import AddressSelect from './formElements/AddressSelect.js';
import AddressSelectButtonGroup from './formElements/AddressSelectButtonGroup.js';
import Select from './formElements/Select.js';

var DetermineFieldType = function DetermineFieldType(_ref) {
  var field = _ref.field,
    submitButton = _ref.submitButton,
    _ref$formRef = _ref.formRef,
    formRef = _ref$formRef === void 0 ? '' : _ref$formRef,
    _ref$inlineButton = _ref.inlineButton,
    inlineButton = _ref$inlineButton === void 0 ? false : _ref$inlineButton,
    _ref$nextStep = _ref.nextStep,
    nextStep = _ref$nextStep === void 0 ? null : _ref$nextStep,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$radioFieldsAsBut = _ref.radioFieldsAsButtons,
    radioFieldsAsButtons = _ref$radioFieldsAsBut === void 0 ? false : _ref$radioFieldsAsBut,
    _ref$smartyStreetsWeb = _ref.smartyStreetsWebsiteKey,
    smartyStreetsWebsiteKey = _ref$smartyStreetsWeb === void 0 ? null : _ref$smartyStreetsWeb;
  var type = field.type,
    element = field.element,
    name = field.name,
    label = field.label,
    instructions = field.instructions,
    value = field.value,
    options = field.options,
    required = field.required,
    placeholderText = field.placeholderText;

  // If we want the submit button and the input be inline we need to create a case for
  // that input type. It should only be done on certain input types (text, number, email)
  // and not date types or other things that would look weird inline.
  var allowedTextTypes = ['text', 'email', 'number', 'tel'];
  var inputType = allowedTextTypes.includes(type) && inlineButton ? 'inputButtonGroup' : type;

  // If we're in a multistep form we render radio type inputs
  // as buttons and manage the state ourselves via the nextStep prop.
  if (radioFieldsAsButtons && type === 'radio') inputType = 'radioButtons';

  // If we're in a form we render address elements with help from
  // Smarty streets
  if (type === 'text' && name === 'address' && smartyStreetsWebsiteKey) inputType = 'address';
  if (inputType === 'address' && inlineButton) {
    inputType = 'addressButtonGroup';
  }
  if (element === 'select' && type !== 'multiSelect') {
    inputType = 'singleSelect';
  }
  switch (inputType) {
    case 'inputButtonGroup':
      return /*#__PURE__*/React.createElement(InputButtonGroup, {
        className: "leshen-input-button-group",
        name: name,
        type: type,
        label: label,
        validations: determineValidations(field),
        submitButton: submitButton,
        placeholderText: placeholderText
      });
    case 'email':
    case 'text':
    case 'number':
    case 'tel':
      return /*#__PURE__*/React.createElement(Input, {
        className: "leshen-input-".concat(inputType),
        type: type,
        name: name,
        label: label,
        validations: determineValidations(field),
        placeholderText: placeholderText
      });
    case 'hidden':
      return /*#__PURE__*/React.createElement(Hidden, {
        name: name,
        initialValue: value
      });
    case 'checkbox':
      return /*#__PURE__*/React.createElement(Checkbox, {
        className: "leshen-input-checkbox",
        options: options,
        name: name,
        label: label,
        validations: determineValidations(field),
        onChange: onChange,
        formRef: formRef
      });
    case 'radioButtons':
      return /*#__PURE__*/React.createElement(StepButtons, {
        className: "leshen-input-radio-buttons",
        options: options,
        name: name,
        label: label,
        instructions: instructions,
        nextStep: nextStep
      });
    case 'radio':
      return /*#__PURE__*/React.createElement(Radio, {
        className: "leshen-input-radio",
        options: options,
        name: name,
        label: label,
        required: required,
        validations: determineValidations(field)
      });
    case 'singleSelect':
      return /*#__PURE__*/React.createElement(Select, {
        className: "leshen-input-select",
        options: options,
        type: type,
        name: name,
        label: label,
        validations: determineValidations(field),
        placeholderText: placeholderText
      });
    case 'address':
      return /*#__PURE__*/React.createElement(AddressSelect, {
        className: "leshen-input-address",
        type: type,
        name: name,
        label: label,
        validations: determineValidations(field),
        placeholderText: placeholderText,
        smartyStreetsWebsiteKey: smartyStreetsWebsiteKey
      });
    case 'addressButtonGroup':
      return /*#__PURE__*/React.createElement(AddressSelectButtonGroup, {
        className: "leshen-input-address-group",
        type: type,
        name: name,
        label: label,
        validations: determineValidations(field),
        placeholderText: placeholderText,
        smartyStreetsWebsiteKey: smartyStreetsWebsiteKey,
        submitButton: submitButton
      });
    default:
      return null;
  }
};
var DetermineFieldType$1 = DetermineFieldType;

export { DetermineFieldType$1 as default };
//# sourceMappingURL=DetermineFieldType.js.map
